import { React, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityOutlinedIcon from "@mui/icons-material/Visibility";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ToastContainer, toast } from "react-toastify";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import "react-toastify/dist/ReactToastify.css";
import AddIcon from "@mui/icons-material/Add";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import nodata from "assets/images/nodata.png";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { set } from "date-fns";

function Campus() {
  // Variable Declaration
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [address, setAddress] = useState("");
  const [contact_no, setContactNo] = useState("");
  const [campuses, setCampuses] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [showAddCampusModal, setshowAddCampusModal] = useState(false);
  const [showUpdateCampusModal, setshowUpdateCampusModal] = useState(false);
  const [showDeleteCampusModal, setshowDeleteCampusModal] = useState(false);
  const [showAssignDepartmentsModal, setShowAssignDepartmentsModal] =
    useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedCampusId, setSelectedCampusId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchKeywordAssign, setSearchKeywordAssign] = useState("");
  const [showViewCampusModal, setShowViewCampusModal] = useState(false);
  const [formErrors, setFormErrors] = useState({
    name,
    address,
    contact_no,
  });

  const callErrors = (NAME, ADDRESS, CONTACT_NO) => {
    const errors = {};
    if (NAME === "") {
      errors.name = " * Campus Name is Required";
    }
    if (ADDRESS === "") {
      errors.address = " * Campus Address is Required";
    }
    if (CONTACT_NO === "") {
      errors.contact_no = " * Campus Contact No is Required";
    }

    setFormErrors(errors);
  };

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getCampuses();
    } else {
      let filteredCampuses = campuses.filter((camp) => {
        const nameMatch =
          camp.name && camp.name.toLowerCase().includes(searchTerm);
        const descriptionMatch =
          camp.description &&
          camp.description.toLowerCase().includes(searchTerm);
        const addressMatch =
          camp.address && camp.address.toLowerCase().includes(searchTerm);
        const contactNoMatch =
          camp.contact_no && camp.contact_no.toLowerCase().includes(searchTerm);

        return nameMatch || descriptionMatch || addressMatch || contactNoMatch;
      });
      setCampuses(filteredCampuses);
    }
  };

  // const handleSearchKeywordAssignChange = (e) => {
  //   const searchTerm = e.target.value.trim().toLowerCase();
  //   setSearchKeywordAssign(searchTerm);

  //   if (searchTerm === "") {
  //     getDepartments();
  //   } else {
  //     let filteredDepartments = departments.filter((dept) => {
  //       const departmentNameMatch =
  //         dept.department_name &&
  //         dept.department_name.toLowerCase().includes(searchTerm);
  //       const descriptionMatch =
  //         dept.description &&
  //         dept.description.toLowerCase().includes(searchTerm);

  //       return departmentNameMatch || descriptionMatch;
  //     });

  //     setDepartments(filteredDepartments);
  //   }
  // };

  //Dialog Settings
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [opens, setOpens] = useState(false);
  const [currentAppId, setCurrentAppId] = useState(null);

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget);
    setOpens(true);
    setCurrentAppId(appId);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpens(false);
    setCurrentAppId(null);
  };

  // Session Storage Calls
  var user = JSON.parse(sessionStorage.getItem("user"));
  if (user) {
    var organization_id = user.organization_id;
  } else {
    var organization_id = null;
  }

  // const assignDepartmentsColumns = [
  //   { Header: "#", accessor: "serial", align: "left" },
  //   { Header: "Department", accessor: "department", align: "left" },
  //   { Header: "Description", accessor: "description", align: "center" },
  //   { Header: "Actions", accessor: "actions", align: "center" },
  // ];
  // const assignDepartmentsRows =
  //   departments.length > 0
  //     ? departments.map((dept, index) => {
  //         return {
  //           serial: index + 1,
  //           department: dept.name,
  //           description: dept.description,
  //           actions: (
  //             <>
  //               {selectedDepartment.includes(dept.id) ? (
  //                 <IconButton
  //                   aria-label="remove"
  //                   onClick={() => handleRemoveDepartment(dept.id)}
  //                 >
  //                   <CheckCircleIcon style={{ color: "green" }} />
  //                 </IconButton>
  //               ) : (
  //                 <IconButton
  //                   aria-label="add"
  //                   onClick={() => handleAddDepartment(dept.id)}
  //                 >
  //                   <RadioButtonUncheckedIcon style={{ color: "grey" }} />
  //                 </IconButton>
  //               )}
  //             </>
  //           ),
  //         };
  //       })
  //     : [
  //         {
  //           serial: null,
  //           department: null,
  //           description: null,
  //           actions: null,
  //         },
  //       ];

  // GET Api calls
  const getCampuses = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(`${BASE_URL}/campus/get_campuses`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setCampuses(data.campuses);
      })
      .catch((error) => console.log(error));
  };

  // const getDepartments = async () => {
  //   const requestOptions = {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Token ${token}`,
  //     },
  //   };
  //   await fetch(`${BASE_URL}/department/get_departments`, requestOptions)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setDepartments(data.departments);
  //     })
  //     .catch((error) => console.log(error));
  // };

  // Add Functions
  const showCampusAddModal = () => {
    setshowAddCampusModal(true);
  };
  const handleOkAddCampusModal = () => {
    if (name && description) {
      addCampus();
      setshowAddCampusModal(false);
    } else {
      callErrors(name, description);
    }
  };

  const handleCancelAddCampusModal = () => {
    setshowAddCampusModal(false);
    setDescription("");
    setName("");
    setFormErrors({
      name: "",
          description: "",
          address: "",
          contact_no: "",
    });
  };

  const addCampus = () => {
    let data = { name, description, address, contact_no };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(`${BASE_URL}/campus/add_campus`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getCampuses();
        toast.success("Campus added successfully");
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setDescription("");
        setName("");
        setAddress("");
        setContactNo("");
      });
  };

  // Delete Functions
  const showCampusDeleteModal = () => {
    setshowDeleteCampusModal(true);
  };
  const handleOkDeleteCampusModal = () => {
    deleteCampus();
    setshowDeleteCampusModal(false);
  };
  const handleCancelDeleteCampusModal = () => {
    setshowDeleteCampusModal(false);
  };
  const deleteCampus = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(
      `${BASE_URL}/campus/delete_campus/${currentAppId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        getCampuses();
        toast.success("Campus deleted successfully");
      })
      .catch((error) => console.log(error));
  };

  // Update Functions
  const showCampusUpdateModal = () => {
    setshowUpdateCampusModal(true);
    getCampusbyId();
  };
  
  const handleOkUpdateCampusModal = () => {
    if (name && description) {
      updateCampus();
      setshowUpdateCampusModal(false);
    } else {
      callErrors(name, description);
    }
  };
  const handleCancelUpdateCampusModal = () => {
    setshowUpdateCampusModal(false);
    setDescription("");
    setName("");
    setFormErrors({
      name: "",
          description: "",
          address: "",
          contact_no: "",
    });
  };

  const handleshowAssignDepartmentsModal = () => {
    setSelectedCampusId(currentAppId);
    getSelectedDepartments();
    setShowAssignDepartmentsModal(true);
  };
  const handleOkAssignDepartmentsModal = () => {
    assignDepartments();
    setShowAssignDepartmentsModal(false);
  };
  const handleCancelAssignDepartmentsModal = () => {
    setShowAssignDepartmentsModal(false);
    setSelectedDepartment([]);
    setSelectedCampusId(null);
  };

  // const assignDepartments = async () => {
  //   if (selectedCampusId) {
  //     let data = {
  //       campus_id: selectedCampusId,
  //       department_ids: selectedDepartment,
  //     };
  //     console.log("data", data);
  //     const requestOptions = {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Token ${token}`,
  //       },
  //       body: JSON.stringify(data),
  //     };
  //     await fetch(
  //       `${BASE_URL}/campus/assignDepartmentsToCampus`,
  //       requestOptions
  //     )
  //       .then((response) => response.json())
  //       .then((data) => {
  //         getDepartments();
  //         toast.success("Departments Assigned Successfully");
  //       })
  //       .catch((error) => console.log(error))
  //       .finally(() => {
  //         setSelectedDepartment([]);
  //         setSelectedCampusId(null);
  //       });
  //   }
  // };

  const getSelectedDepartments = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    await fetch(
      `${BASE_URL}/campus/assignedDepartmentsinCampus/${currentAppId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        const selectedDepartment = data.campus_department.map(
          (dept) => dept.department_id
        );
        setSelectedDepartment(selectedDepartment);
      })
      .catch((error) => console.log(error));
  };

  const handleAddDepartment = (id) => {
    setSelectedDepartment([...selectedDepartment, id]);
  };
  const handleRemoveDepartment = (id) => {
    const filteredDepartments = selectedDepartment.filter(
      (dept) => dept !== id
    );
    setSelectedDepartment(filteredDepartments);
  };

  const getCampusbyId = () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${BASE_URL}/campus/getCampusbyId/${currentAppId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        setName(data.campus[0].name);
        setDescription(data.campus[0].description);
        setAddress(data.campus[0].address);
        setContactNo(data.campus[0].contact_no);
      })
      .catch((err) => console.log("err: ", err));
  };

  const viewCampus = (id) => {
    const campus = campuses.find((d) => d.id === id);
    setSelectedCampusId(campus);
    setShowViewCampusModal(true);
  };

  const updateCampus = () => {
    let data = {
      id: currentAppId,
      name: name,
      description: description,
      address: address,
      contact_no: contact_no,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify(data),
    };
    fetch(`${BASE_URL}/campus/update_campus`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getCampuses();
        toast.success("Campus updated successfully");
      })
      .catch((err) => console.log("err: ", err))
      .finally(() => {
        setDescription("");
        setName("");
        setAddress("");
        setContactNo("");
        setFormErrors({
          name: "",
          description: "",
          address: "",
          contact_no: "",
        });
      });
  };

  const handleFocus = (e) => {
    const { name } = e.target;

    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }));
  };

  // Rows & Columns Injection
  const columns = [
    { Header: "#", accessor: "serial", align: "center" },
    { Header: "Campus Name", accessor: "campus_name", align: "left" },
    { Header: "Address", accessor: "address", align: "left" },
    { Header: "Contact No", accessor: "contact_no", align: "center" },
    { Header: "Type", accessor: "type", align: "center" },
    // { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows =
    campuses.length > 0
      ? campuses.map((campus, index) => ({
          serial: index + 1,
          campus_name: campus.name,
          address: campus.address,
          contact_no: campus.contact_info,
          type: campus.type,
          actions: (
            <>
              <IconButton onClick={showCampusUpdateModal}>
                <EditIcon className="icon-button-edit" />
              </IconButton>
              <IconButton onClick={() => viewCampus(campus.id)}>
                <VisibilityOutlinedIcon className="icon-button-view" />
              </IconButton>
              <IconButton onClick={showCampusDeleteModal}>
                <DeleteIcon className="icon-button-delete" />
              </IconButton>
              {/* <IconButton onClick={handleshowAssignDepartmentsModal}>
                <PlaylistAddIcon className="icon-button-assign" />
              </IconButton> */}
            </>
          ),
        }))
      : [
          {
            serial: null,
            campus_name: null,
            description: null,
            actions: null,
          },
        ];

  // Initial Renderings
  useEffect(() => {
    getCampuses();
    // getDepartments();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ width: "100%" }}
                >
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper className="search-paper" component="form">
                      <InputBase
                        sx={{
                          ml: 1,
                          flex: 1,
                          "&::placeholder": {
                            color: "blue",
                          },
                        }}
                        placeholder="Search"
                        // inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon className="search-icon" />
                    </Paper>
                  </Stack>
                  {/* <Button
                    variant="filled"
                    endIcon={<AddIcon className="add-icon" />}
                    onClick={showCampusAddModal}
                    className="add-button"
                  >
                    Add
                  </Button> */}
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {campuses && campuses.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Add Campus */}
      <Dialog
        fullScreen={fullScreen}
        open={showAddCampusModal}
        onClose={handleCancelAddCampusModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title " className="dialog-title">
          {"Add Campus"}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Name"
                />
              </div>
              <div className="error-message1">{formErrors.name}</div>
            </div>
            <div className="col-md-6 mt-3">
              <label>Address</label>
              <input
                name="address"
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                onFocus={handleFocus}
                className="form-control form-control-lg"
                placeholder="Enter Address"
              />
              <div className="error-message">{formErrors.address}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Contact No</label>
                <input
                  name="contact_no"
                  type="text"
                  value={contact_no}
                  onChange={(e) => setContactNo(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Contact No"
                  style={{
                    width: "240px",
                    height: "40px",
                    borderRadius: "10px",
                    border: "1px solid #DBDBDB",
                    opacity: 1,
                    padding: "0 19px",
                    color: "#ACACAC",
                  }}
                />
                <div className="error-message1">{formErrors.contact_no}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mt-3">
                <label>Description</label>
                <input
                  name="description"
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Description"
                />
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelAddCampusModal}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkAddCampusModal}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog
        fullScreen={fullScreen}
        open={showDeleteCampusModal}
        onClose={handleCancelDeleteCampusModal}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            width: "450px",
            borderRadius: "20px",
            opacity: 1,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          {"Delete Campus"}
        </DialogTitle>
        <DialogContent className="content-delete">
          Are you sure you want to delete this Campus?
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelDeleteCampusModal}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkDeleteCampusModal}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Dialog */}
      <Dialog
        fullScreen={fullScreen}
        open={showUpdateCampusModal}
        onClose={handleCancelUpdateCampusModal}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          {"Update Campus"}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Name"
                />
              </div>
              <div className="error-message1">{formErrors.name}</div>
            </div>
            <div className="col-md-6 mt-3">
              <label>Address</label>
              <input
                name="address"
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                onFocus={handleFocus}
                className="form-control form-control-lg"
                placeholder="Enter Address"
              />
              <div className="error-message">{formErrors.address}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Contact No</label>
                <input
                  name="contact_no"
                  type="text"
                  value={contact_no}
                  onChange={(e) => setContactNo(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Contact No"
                />
                <div className="error-message1">{formErrors.contact_no}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mt-3">
                <label>Description</label>
                <input
                  name="name"
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Description"
                />
              </div>
              <div className="error-message">{formErrors.description}</div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={handleCancelUpdateCampusModal}
          >
            Cancel
          </Button>
          <Button
            className="dialog-actions-button positive"
            onClick={handleOkUpdateCampusModal}
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Batch Dialog */}
      <Dialog
        open={showViewCampusModal}
        onClose={() => setShowViewCampusModal(false)}
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          View Batch
        </DialogTitle>
        <DialogContent className="dialog-content">
          {selectedCampusId && (
            <>
              <div className="flex-container">
                <strong className="label1">Campus Name</strong>
                <span className="value1">{selectedCampusId.name}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Address</strong>
                <span className="value1">{selectedCampusId.address}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Contact No</strong>
                <span className="value1">{selectedCampusId.contact_info}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Type</strong>
                <span className="value1">{selectedCampusId.type}</span>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="dialog-actions-button negative"
            onClick={() => setShowViewCampusModal(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Assign Departments */}
      {/* <Dialog
        fullScreen={fullScreen}
        open={showAssignDepartmentsModal}
        onClose={handleCancelAssignDepartmentsModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Assign Departments"}
        </DialogTitle>
        <DialogContent>
          <div className="row">
            <div className="col-md-12">
              <div className="form-outline mt-3 mb-3">
                <InputBase
                  placeholder="Search"
                  inputProps={{ "aria-label": "search voucher" }}
                  value={searchKeywordAssign}
                  onChange={handleSearchKeywordAssignChange}
                />
                <SearchIcon />
              </div>
            </div>
          </div> */}
      {/* <DataTable
            table={{
              columns: assignDepartmentsColumns,
              rows: assignDepartmentsRows,
            }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          /> */}
      {/* </DialogContent>
        <DialogActions>
          <Button negative onClick={handleCancelAssignDepartmentsModal}>
            Cancel
          </Button>
          <Button positive onClick={handleOkAssignDepartmentsModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog> */}
    </DashboardLayout>
  );
}

export default Campus;
